export enum LostLoanType {
    CounterOffer = 0,
    WithdrawnByClient = 1,
    Incomplete = 2,
    Other = 3,
}

export const LostLoanTypeOptions = [
    {
        id: LostLoanType.CounterOffer,
        name: 'Counteroffer',
    },
    {
        id: LostLoanType.WithdrawnByClient,
        name: 'Withdrawn by Client',
    },
    {
        id: LostLoanType.Incomplete,
        name: 'Incomplete',
    },
    {
        id: LostLoanType.Other,
        name: 'Other',
    },
];
